import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './layouts/AppShell';
import { DashboardPage } from './pages/DashboardPage';
import { TicketListPage } from './pages/TicketListPage';
import { TicketDetailPage } from './pages/TicketDetailPage';
import { ReportsPage } from './pages/ReportsPage';
import { ThemeRunDetailPage } from './pages/ThemeRunDetailPage';
import { SettingsPage } from './pages/SettingsPage';
import { ExperimentRunDetailPage } from './pages/ExperimentRunDetailPage';
import { UserGuidePage } from './pages/UserGuidePage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/tickets" element={<TicketListPage />} />
          <Route path="/tickets/:ticketId" element={<TicketDetailPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/reports/themes/:jobId" element={<ThemeRunDetailPage />} />
          {/* Moved into Settings. Redirect rather than drop it, so existing links
              and bookmarks to /experiments keep working. */}
          <Route path="/experiments" element={<Navigate to="/settings?tab=experiments" replace />} />
          <Route path="/experiments/:runId" element={<ExperimentRunDetailPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/help" element={<UserGuidePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
